export default class RingTreeTargetDashboardService {

  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    utils,
    cacheService
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.utils = utils;
    this.cacheService = cacheService;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  async getRttDashboardLogs(accountId, dates) {
      const start = dates[0];
      const end = dates[1];
      
      const url = this.#serviceBaseUrl(accountId) + '?Start=' + start + '&End=' + end

      const result = await this.$http.get(url);

      return result.data;
  }

  async getRttLastErrors(accountId, cellProps) {
    const rttId = cellProps.row.rttId;
    const rejection = cellProps.col.key.split(':')[1];
    
    const url = `${this.#serviceBaseUrl(accountId)}/recentCalls/${rttId}/${rejection}`

    const result = await this.$http.get(url);

    return result.data;
  }
  
  #serviceBaseUrl(accountId) {
    return this.serviceBaseUri + accountId + '/stats/rtt';
  }
}